import styled from 'styled-components'
import { Link } from 'gatsby'
import media from '../../../styles/media'

export const HeaderCustom = styled.header`
  background-color: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  position: sticky;
  display: flex;
  z-index: 1020;
`

export const Image = styled.img`
  width: 150px;
  ${media.md`
    width: 260px;
  `}
`

export const Container = styled.div`
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ${media.md`
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}
`

export const LinkCustom = styled(Link)`
  padding: 4px;
  color: #999;
  text-decoration: none;
  font-size: 12px;

  ${media.md`
    padding: 10px;  
    font-size: 14px;
  `}
`
export const SubmenuButton = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  outline: 0;
  cursor: pointer;
`

export const Submenu = styled.ul`
  position: absolute;
  top: 50%;
  list-style-type: none;
  padding: 1rem 1rem 1rem 0;
  border: solid 1px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  background-color: white;
  border-radius: 0.25rem;
  min-width: 150px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
